module.exports = __webpack_public_path__ + "img/ic_done.dee9fe00.svg";